<main property="mainContentOfPage" class="container" typeof="WebPageElement">
  <!-- Main body contains the router outlet -->
  <carm-main-body-section></carm-main-body-section>
  <!-- Main bottom bottom - contains the report a problem on this page -->
<!--  <carm-main-body-bottom></carm-main-body-bottom>-->
</main>
